module.exports = __webpack_public_path__ + "static/media/0017.5ac19d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48103/RAL/0017.png
// module id = 1586
// module chunks = 0